import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';

const SIZES = {
  small: '20px',
  default: '36px',
  large: '48px',
};

const Spinner = ({
  className,
  size = 'default',
  appearance = 'dark',
  ...props
}) => (
  <svg
    version="1.1"
    id="loader-1"
    xmlns="http://www.w3.org/2000/svg"
    x="0px"
    y="0px"
    width={SIZES[size]}
    height={SIZES[size]}
    viewBox="0 0 50 50"
    style={{ enableBackground: 'new 0 0 50 50', ...props.style }}
    xmlSpace="preserve"
    className={clsx(className, 'fill-current', {
      'text-gray-500': appearance === 'dark',
      'text-gray-100': appearance === 'light',
    })}
    {...props}
  >
    <path d="M43.935,25.145c0-10.318-8.364-18.683-18.683-18.683c-10.318,0-18.683,8.365-18.683,18.683h4.068c0-8.071,6.543-14.615,14.615-14.615c8.072,0,14.615,6.543,14.615,14.615H43.935z">
      <animateTransform
        attributeType="xml"
        attributeName="transform"
        type="rotate"
        from="0 25 25"
        to="360 25 25"
        dur="0.8s"
        repeatCount="indefinite"
      />
    </path>
  </svg>
);

Spinner.propTypes = {
  className: PropTypes.string,
};

Spinner.defaultProps = {
  className: '',
};

export default Spinner;
